import { render } from "./SobreNosComp.vue?vue&type=template&id=fb3318ba&scoped=true"
import script from "./SobreNosComp.vue?vue&type=script&lang=js"
export * from "./SobreNosComp.vue?vue&type=script&lang=js"

import "./SobreNosComp.vue?vue&type=style&index=0&id=fb3318ba&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb3318ba"]])

export default __exports__